<template>
    <BulkUpload></BulkUpload>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const BulkUpload = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/PartMaintenance/BulkUpload.vue"
    )
);

export default {
    name: "Project_HelpBulkUpload", //The name you are in should not equal the name of the component you are importing.
    components: { BulkUpload, AuthLayout },
};
</script>
